import React from "react";

import { Navigate, useRoutes } from "react-router-dom";
import PropTypes from "prop-types";
import DashboardLayout from "./dashboard-layout";
import OverviewContainer from "../containers/overview-container";
import Settings from "./settings";
import SyncLogsContainer from "../containers/sync-logs-container";
import Support from "./support";
import AllSet from "./all-set";
import { SQUARE_USER_PROP_TYPES, UNKNOWN_USER } from "../constants/proptypes";

const Dashboard = ({
  refetchSession,
  squareUser = UNKNOWN_USER,
  zendeskWidgetEnabled,
}) =>
  useRoutes([
    {
      path: "/*",
      element: (
        <DashboardLayout
          refetchSession={refetchSession}
          squareUser={squareUser}
          zendeskWidgetEnabled={zendeskWidgetEnabled}
        />
      ),
      children: [
        {
          index: true,
          element: <OverviewContainer />,
        },
        {
          path: "settings",
          element: <Settings />,
        },
        {
          path: "sync-logs",
          element: <SyncLogsContainer />,
        },
        {
          path: "support",
          element: <Support zendeskWidgetEnabled={zendeskWidgetEnabled} />,
        },
        { path: "all-set", element: <AllSet /> },
        {
          path: "*",
          element: <Navigate replace to="/" />,
        },
      ],
    },
  ]);

Dashboard.propTypes = {
  refetchSession: PropTypes.func.isRequired,
  squareUser: SQUARE_USER_PROP_TYPES,
  zendeskWidgetEnabled: PropTypes.bool.isRequired,
};

export default Dashboard;
